import { defineComponent as _defineComponent } from 'vue'
import { mastersService } from '@/services/masters.service';
import { ClickMenu } from './menu';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventModuleFilter',
  props: {
    value: { default: () => [] },
    position: { default: 'is-bottom-left' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: string[]) => void), expose: any, slots: any, attrs: any }) {





function emitValue(event: string | number | (string | number)[]) {
  emit('input', event as string[]);
}

const modules = computed<string[]>(() =>
  mastersService.store.getEventModules(),
);

return { __sfc: true,emit, emitValue, modules, ClickMenu }
}

})